import(/* webpackMode: "eager" */ "/home/runner/work/puramente-onboarding/puramente-onboarding/src/app/global-error.tsx");
